<template>
  <span></span>
</template>

<script>

export default {
  name: 'HoneybadgerErrorTracking',
  mounted () {

    if (this.$page.props.env === 'local') {
      this.$honeybadger.configure({
        reportData: false,
      });

      return

    }

      if (!this.$page.props.auth.user) {
        return
      }

      this.$honeybadger.setContext({
        user_id: this.$page.props.auth.user.id,
        user_email: this.$page.props.auth.user.email
      })
    }
  ,
  }

</script>

